import { render } from "./ForgotPassForm.vue?vue&type=template&id=1dbf52ad&scoped=true"
import script from "./ForgotPassForm.vue?vue&type=script&lang=js"
export * from "./ForgotPassForm.vue?vue&type=script&lang=js"

import "./ForgotPassForm.vue?vue&type=style&index=0&id=1dbf52ad&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbf52ad"]])

export default __exports__